export const ALLOCATE_PAYMENTS = gql`
    mutation AllocatePayments($input: AllocatePaymentsInput!) {
        allocatePayments(input: $input) {
            message
        }
    }
`;
